module.exports = __webpack_public_path__ + "media/app/assets/races/mechagnome_male-741239ec4ca6d89782e13e1fb5c0971f.png";